module.exports = __webpack_public_path__ + "static/media/token-preview-morning-sun.ae0f8578.png";